import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sanskrutik-mohotsav',
  templateUrl: './sanskrutik-mohotsav.component.html',
  styleUrls: ['./sanskrutik-mohotsav.component.scss']
})
export class SanskrutikMohotsavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
